import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useStateSelector } from '../../../store/selectors';
import { FetchDataRoom } from '../../../slices/marketplace/data-room/thunks/fetch-data-room.thunk';
import DataRoom from '../DataRoom/DataRoom';
import { SourceType } from '../../../slices/marketplace/data-room/models/vdr-access-permission.model';

interface EngagementDataRoomHostProps {
    isReadonly?: boolean
}

const EngagementDataRoomHost: React.FC<EngagementDataRoomHostProps> = ({
    isReadonly
}) => {
    const dispatch = useDispatch() as any;
    const { engagementId } = useParams<{ engagementId: string }>();
    const engagementIdNum = Number(engagementId);

    const rootFolder = useStateSelector(
        (state) => state.dataRoomState.rootFolder
    );
    const currentEngagement = useStateSelector(
        (state) => state.timelines.currentTimeline
    );

    const fetchDataRoom = useCallback(() => {
        if (engagementIdNum && !isNaN(engagementIdNum)) {
            dispatch(
                FetchDataRoom({
                    sourceId: engagementIdNum,
                    sourceType: SourceType.Engagement,
                })
            );
        }
    }, [dispatch, engagementIdNum]);

    useEffect(() => {
        fetchDataRoom();
    }, [fetchDataRoom]);

    const handlePermissionsUpdated = useCallback(() => {
        fetchDataRoom();
    }, [fetchDataRoom]);

    const handleFileRemoved = useCallback(() => {
        fetchDataRoom();
    }, [fetchDataRoom]);

    return (
        <DataRoom
            engagementId={engagementIdNum}
            rootFolder={rootFolder}
            practices={currentEngagement?.engagementProcess?.practices || []}
            teamMembers={[]}
            memberOwnerId={0}
            onPermissionsUpdated={handlePermissionsUpdated}
            onFileRemoved={handleFileRemoved}
            canUserManagePermissions={false}
            isReadonly={!!isReadonly}
        />
    );
};

export default EngagementDataRoomHost;
